<template>
  <component
    :is="component"
    v-if="component"
    :block="block"
    @download="emit('download', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Component } from 'vue'
import type { Block, CardBlock } from '../../types'
import BLOCK_REGISTRY from './block-registry'
import CardBlockComponent from './block.vue'
import MarkdownBlock from './markdown.vue'
import PromptBlock from './prompt.vue'

/* one component per block type; `prompt` is the merchant's message, `markdown` an answer text part; `deep_link` is reserved and, like any unknown type, renders nothing */
const COMPONENTS: Readonly<Partial<Record<string, Component>>> = {
  ...BLOCK_REGISTRY,
  prompt: PromptBlock,
  markdown: MarkdownBlock,
  card: CardBlockComponent
}

const props = defineProps<{
  block: Block
}>()

const emit = defineEmits<{
  download: [block: CardBlock]
}>()

const component = computed(() =>
  props.block.type ? COMPONENTS[props.block.type] : undefined
)
</script>
